import { render, staticRenderFns } from "./dropShipping.vue?vue&type=template&id=c83eaa72&scoped=true&"
import script from "./dropShipping.vue?vue&type=script&lang=js&"
export * from "./dropShipping.vue?vue&type=script&lang=js&"
import style0 from "./dropShipping.vue?vue&type=style&index=0&id=c83eaa72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83eaa72",
  null
  
)

export default component.exports